module.exports = __webpack_public_path__ + "static/img/icon_phone.49881b67.png";